/* eslint-disable camelcase */

export default class loadSequence {
  constructor ({ description, id, password, retail_id, username }) {
    this.description = description
    this.id = id
    this.password = password
    this.retailId = retail_id
    this.username = username
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/LoadSequence.js